import black from '@assets/images/black.png'
import green from '@assets/images/green.png'
import red from '@assets/images/red.png'

export const COLOR_IMAGE: { [x: string]: string } = {
  black: black,
  green: green,
  red: red,
}
